import React, {useState, useEffect} from 'react'
import Slider from 'react-slick';
import { useDispatch,useSelector } from "react-redux";
import { generatePresignedURL,CloudFileUpload } from "../../../Redux/Actions/cloudFileUpload";
import "./style.css";
import { deleteSubmission, fetchNormalSubmission, introVideoDetails, secondStepDetails, togglePublic, updateIntroVideo, uploadWithoutPresigned } from '../../../Redux/Actions/ProfileSteps';
import VideoSection from './components/videosection';
import { Loading } from 'notiflix';
import ReactPlayer from 'react-player';
import { APIURL } from '../../../Redux/Actions/config';
import axios from 'axios';
import Base from '../../../Components/Layout/Base';
import { useLocation } from 'react-router-dom';
const IntroductionVideo = ({setCurrentStep}) => {
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [videoFile, setVideoFile] = useState(null);
  const [videoPreview, setVideoPreview] = useState(null);
  const [isDragging, setIsDragging] = useState(false);
  const [error, setError] = useState("");
  const [playingId, setPlayingId] = useState(null);
  const displayData = location?.state
  const [localData, setLocalData] = useState([]);
  const [localLoading, setLocalLoading] = useState({});
  const boxData = [
    "💡 Text resumes look the same. Your voice and energy are unique, add a video to your portfolio in less than a minute!",
    "💡 Profiles with video have a 3x higher recall rate. Upload a simple short video to your portfolio and turn a 'maybe' into a 'yes.'",
    "💡 Don't leave your profile at 90%. That last 10%—the video—is what bridges the gap between you and your dream team.",
    "💡 It takes less than 2 minutes to record a clip that proves your communication skills are as good as your resume says they are.",
    "💡 You wouldn't walk into an interview without saying hello. Don't let your profile be silent. The first impression happens before the interview now",
    "💡 Did you know? Recruiters spend 3x more time on profiles with video, add a video to your portfolio in less than a minute!"
  ]
  const dispatch = useDispatch();
  const kids = useSelector(state => state.dashboard.kids);
  const profileData = useSelector(s => s.ProfileSteps.profileData);
  const submissionData = useSelector(s => s.ProfileSteps.submissionData);
  const SecondStepData = useSelector(s => s.ProfileSteps.SecondStepData);
  const data = useSelector(s => s.ProfileSteps.introData);
  useEffect(() => {
    kids && kids[0]?.id && dispatch(fetchNormalSubmission({ kid_id: kids[0]?.id , activity_id:displayData?.activity?.activity_id }))
    kids && kids[0]?.id && dispatch(secondStepDetails({ kid_id: kids[0]?.id ,activity_id:displayData?.activity?.activity_id}))
  },[kids])

  // Sync local state with Redux data when it changes
  useEffect(() => {
    if (submissionData) {
      setLocalData(submissionData?.submission);
    }
  }, [submissionData]);

  // Cleanup video preview URL on unmount
  useEffect(() => {
    return () => {
      if (videoPreview) {
        URL.revokeObjectURL(videoPreview);
      }
    };
  }, [videoPreview]);
  useEffect(() => {
    if (loading) Loading.standard("Uploading...");
    else Loading.remove();
  }, [loading]);

  // Toggle public state locally with optimistic update
  const handleTogglePublic = (submissionId) => {
    setLocalLoading(prev => ({ ...prev, [submissionId]: true }));
    
    // Optimistic update
    setLocalData(prev => 
      prev?.map(item => 
        item.csnUniqueId === submissionId 
          ? { ...item, isPublic: !item.isPublic }
          : item
      )
    );

    // API call
    dispatch(togglePublic({ submissionId }))
      .then(() => {
        setLocalLoading(prev => ({ ...prev, [submissionId]: false }));
        // Redux will update data, which will sync back to localData
      })
      .catch(() => {
        // Revert on error
        setLocalData(prev => 
          prev?.map(item => 
            item.csnUniqueId === submissionId 
              ? { ...item, isPublic: !item.isPublic }
              : item
          )
        );
        setLocalLoading(prev => ({ ...prev, [submissionId]: false }));
      });
  };

  // Delete item locally with optimistic update
  const handleDeleteSubmission = (submissionId) => {
    setLocalLoading(prev => ({ ...prev, [submissionId]: true }));
    // Optimistic update - remove immediately
    const itemIndex = localData.findIndex(item => item.csnUniqueId === submissionId);
    const deletedItem = localData[itemIndex];
    
    setLocalData(prev => prev.filter(item => item.csnUniqueId !== submissionId));
    
    // Stop playing if deleting current video
    if (playingId === submissionId) {
      setPlayingId(null);
    }

    // API call
    dispatch(deleteSubmission(submissionId))
      .then(() => {
        setLocalLoading(prev => ({ ...prev, [submissionId]: false }));
        // Redux will update data, which will sync back to localData
      })
      .catch(() => {
        // Revert on error - add back the deleted item
        setLocalData(prev => [...prev, deletedItem]);
        setLocalLoading(prev => ({ ...prev, [submissionId]: false }));
      });
  };

  const validateAndSetVideo = (file) => {
    setError("");
    
    if (!file) {
      setError("Please select a file");
      return;
    }

    if (!file.type.startsWith('video/mp4')) {
      setError("Only MP4 files are allowed");
      return;
    }

    const maxSize = 2500 * 1024 * 1024;
    if (file.size > maxSize) {
      setError("File size must be less than 25MB");
      return;
    }

    const previewUrl = URL.createObjectURL(file);
    setVideoFile(file);
    setVideoPreview(previewUrl);
  };

  const handleDragEnter = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
    const file = e.dataTransfer.files[0];
    validateAndSetVideo(file);
  };

  const handleVideoChange = (e) => {
    const file = e.target.files[0];
    validateAndSetVideo(file); 
  };

  const removeVideo = () => {
    if (videoPreview) {
      URL.revokeObjectURL(videoPreview);
    }
    setVideoFile(null);
    setVideoPreview(null);
    setError("");
  };
useEffect(() => {
//   const handleNext = async () => {
//     try {
//       if (!videoFile) {
//         return;
//       }
// const arrayOfFile = [];
//           if (videoFile && videoFile instanceof File) {
//             // uploadedResumeUrl = await new Promise((resolve, reject) => {
//             //   dispatch(generatePresignedURLNew({ file_type: "pdf", upload_type: "EVENTS" }, url => {
//             //   // dispatch(generatePresignedURL({ filetype: "pdf" }, url => {
//             //     if (!url) return reject(new Error("Failed to get presigned URL"));
//             //     // dispatch(CloudFileUpload({ url, file: resumeFile, type: "pdf" }, pdfUrl => {
//             //     //   if (!pdfUrl) return reject(new Error("PDF upload failed"));
//             //     //   resolve(pdfUrl);
//             //     // }));
//             //     const beforePdf = url.slice(0, url.indexOf('.pdf') + 4);
//             //     dispatch(uploadWithoutPresigned({kid_id: kids[0]?.id,"activity_id":1172,"intro_video_url":beforePdf}))
//             //   }));
//             // });
//                         const zip = require("jszip")();
//                         let files = videoFile;
//                         // for (let file = 0; file < fileArray.length; file++) {
//                             // Zip file with the file name.
//                             const value = zip.file(files.name,files);
//                         // }
//                         // setCompressing(true);
//                         // setMsg("Please wait files are proccessing");
//                         zip.generateAsync({ type: "blob", compression: 'DEFLATE', compressionOptions: { level: 9 } }).then((content) => {
//                             // setMsg("Please wait files are getting uploaded");
//                             const formData = new FormData();
//                             formData.append("file",content);
//                             formData.append("consent", true);
//                             var config = {
//                                 method: 'post',
//                                 url: `${APIURL}/api/competition?activityId=1176&competitionId=117&kidId=${kids[0]?.id}`,
//                                 headers: {
//                                     'accept': 'application/json',
//                                     'Content-Type': 'multipart/form-data',
//                                 },
//                                 data: formData,
//                                 // onUploadProgress: (progressEvent) => {
//                                 //     const progress = Math.round((progressEvent.loaded * 100) / progressEvent.total)
//                                 //     setUploadProgress(progress);
//                                 //     if (progress === 100) {
//                                 //         // setMsg("Please wait until server side processing of file is complete.");
//                                 //     }
//                                 // },
//                             };
            
//                             axios(config)
//                                 .then(function (response) {
//                                     // setFileArray([]);
//                                     arrayOfFile.splice(0, arrayOfFile.length);
//                                     const msg = response?.data?.status ? "Submission Successful" : response?.data?.message;
//                                     // setMsg(msg);
//                                     // setReload(Math.floor(1000 + Math.random() * 9000))
//                                     // setTimeout(() => { setMsg("") }, 5000);
//                                 })
//                                 .catch(function (error) {
//                                     // setFileArray([]);
//                                     // setMsg("internal server error!");
//                                     // setUploadProgress(0);
//                                     // setCompressing(false);
//                                     // arrayOfFile = []
//                                     // setTimeout(() => { setMsg("") }, 5000);
//                                 });
//                         });
//           }

//       // setLoading(true);
//       // const presignedUrl = await new Promise((resolve, reject) => {
//       //   dispatch(generatePresignedURL({ filetype: "video" }, (url) => {
//       //     if (!url) return reject(new Error("Presigned URL not received"));
//       //     resolve(url);
//       //   }));
//       // });

//       // const uploadedUrl = await new Promise((resolve, reject) => {
//       //   dispatch(
//       //     CloudFileUpload(
//       //       { url: presignedUrl, file: videoFile, type: "video" },
//       //       (imageUrl) => {
//       //         if (!imageUrl) return reject(new Error("Upload URL not received"));
//       //         resolve(imageUrl);
//       //       }
//       //     )
//       //   );
//       // });

//       // await dispatch(
//       //   updateIntroVideo({
//       //     kid_id: kids[0]?.id,
//       //     intro_video_url: uploadedUrl,
//       //   })
//       // );

//       // setCurrentStep(3);
//     } catch (error) {
//       alert("Upload failed. Please try again.");
//     } finally {
//       setLoading(false);
//     }
//   }

  const handleNext = async () => {
    try {
      if (!videoFile) {
        return;
      }

      setLoading(true);

      const presignedUrl = await new Promise((resolve, reject) => {
        dispatch(generatePresignedURL({ filetype: "video" }, (url) => {
          if (!url) return reject(new Error("Presigned URL not received"));
          resolve(url);
        }));
      });

      const uploadedUrl = await new Promise((resolve, reject) => {
        dispatch(
          CloudFileUpload(
            { url: presignedUrl, file: videoFile, type: "video" },
            (imageUrl) => {
              if (!imageUrl) return reject(new Error("Upload URL not received"));
              resolve(imageUrl);
            }
          )
        );
      });

      await dispatch(
        uploadWithoutPresigned({
          kid_id: kids[0]?.id,
          intro_video_url: uploadedUrl,
          activity_id:displayData?.activity?.activity_id
        })
      );
      await kids && kids[0]?.id && dispatch(fetchNormalSubmission({ kid_id: kids[0]?.id , activity_id:displayData?.activity?.activity_id }))
    } catch (error) {
      console.error("Upload failed:", error);
      alert("Upload failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };


  handleNext();
},[videoFile])

  return (
    <Base>
    <div className='intro-video-step pt-4 pt-lg-5'>
      <div className="container-fluid px-lg-5">
        <div className='content-box gr-box'>
          <h2 className='mb-3 mb-lg-4'>What do you need to do?</h2>
          <div className='d-flex'>
            <img src="./images/image158.png" alt="" className='mb-auto'/>
            <div className='flex-1 ms-3 ms-lg-4'>
              <h2 className='mb-2'>{SecondStepData?.name}</h2>
              <p className='col-md-7'>{SecondStepData?.activity_details?.description?.details?.[0]}</p>
            </div>
          </div>
              <p className='col-md-7 pt-4'>{SecondStepData?.activity_details?.description?.details?.[1]}</p>
              <p className='col-md-7 pt-4'>{SecondStepData?.activity_details?.description?.details?.[2]}</p>
              <p className='col-md-7 pt-4'>{SecondStepData?.activity_details?.description?.details?.[3]}</p>
        </div>
        <div className='content-box px-0'>
          <h2 className='mb-3 mb-lg-4'>Instructions</h2>
          <ol className='ps-3 col-md-7'>
            {SecondStepData?.activity_instructions?.preparation?.map((item)=>{
              return(
            <li>{item}</li>
              )
            })}
          </ol>
        </div>
        <div className='content-box bg-yellow'>
  <p className='col-md-7'>{boxData[Math.floor(Math.random() * boxData.length)]}</p>
</div>
        <div className='content-box px-0'>
          <h2 className='mb-3 mb-lg-4 text-dark'>Basic skill showcase</h2>
          <p className='col-md-7'>You can watch these reference videos to understand what a strong response looks like. Use them to learn, refine your approach, and deliver your best performance. A better submission strengthens your portfolio and increases your chances of landing a job.</p>
        </div>
        <div class="col-md-7">
                <VideoSection/>
        </div>
        
        <div className='content-box d-flex justify-content-between align-items-center col-md-7 bg-yellow-gr'>
          <img src="./images/layer.png" alt="" />
          <h2 className='m-0 text-black fw-normal fs-14 ps-4'>{boxData[Math.floor(Math.random() * boxData.length)]}</h2>
        </div>
        
        <div className='form-bg px-0 bg-transparent col-md-7'>
          <div className='form-group'>
            <label htmlFor="">Upload your video</label>
            
            {/* Error message */}
            {error && (
              <div className="alert alert-danger" role="alert">
                {error}
              </div>
            )}
            
              <div
                className={`drop-uploader col-md-6 ${isDragging ? "dragging" : ""}`}
                onDragEnter={handleDragEnter}
                onDragOver={handleDragOver}
                onDragLeave={handleDragLeave}
                onDrop={handleDrop}
                onClick={() => document.getElementById("videoUpload").click()}
                style={{ cursor: "pointer" }}
              >
                <div>
                  <img src="./svg/download.svg" alt="" className="mb-3" />
                  <p>
                    MP4 file <br />
                    Size: Max 25MB
                  </p>
                </div>
              </div>
            
            <input
              id="videoUpload"
              type="file"
              accept="video/mp4"
              onChange={handleVideoChange}
              style={{ display: "none" }}
            />
          </div>
          
          <div className='content-box px-0 skill-showcase'>
            <p>Kindly record your video in landscape mode and dressed in professional attire. Read the activity details carefully, and feel free to integrate any supporting material into your video for clarity. Only your latest submission appears in your portfolio, so make sure it reflects your best work.  </p>
          </div>
        </div>
      </div>
      <div className="container-fluid px-lg-5">
        <div className='content-box px-0'>
          <h2 className='mb-3 mb-lg-4 text-dark'>Previous Submissions</h2>
          <p className='mb-3 mb-lg-4 text-dark'>*Note : Video showing in the portfolio will be be shared with the application</p>
          {localData && localData?.length > 0 ? localData?.map((item,idx)=>{
            return(
              <>
              {idx > 0 && <hr />}
              <div>
              <div className='icon-with-txt warning-txt'>Grade Awaited</div>
              <div className='skill-duration'>20 mins ago</div>
          </div>
          <div className="row">
            <div className="col-lg-4">
              <div>
                <div className="video-frame p-0">
                  {/* <img src="./svg/play.svg" className="play-icon" alt="Play" />/ */}
                   <video  
                    src={item?.fileUrlDtoList?.[0]?.fileUrl} 
                    controls 
                    style={{ width: '100%', maxHeight: '300px' }}
                  >
                    Your browser does not support the video tag.
                  </video>
                  <button
                    onClick={() => handleDeleteSubmission(item?.csnUniqueId)}
                    className='shadow-circle delete'
                    style={{
                      position: 'absolute',
                      top: '-20px',
                      right: '-20px',
                      background: '#fff',
                      border: 'none',
                      borderRadius: '50%',
                      padding: '8px',
                      cursor: 'pointer'
                    }}
                  >
                    <img src="./svg/trash.svg" alt="delete" />
                  </button>
                  {/* <div className='shadow-circle delete'>
                    <img src="./svg/trash.svg" alt="" />
                  </div> */}
                </div>
                
                <div className="d-flex justify-content-between mt-3">
                      <label className="toggle-switch-main mb-0">
                        <span className="toggle-label">Show in Portfolio</span>
                        <input
                          className="toggle-checkbox"
                          type="checkbox"
                          checked={item?.isPublic}
                          onChange={() => handleTogglePublic(item?.csnUniqueId)}
                        />
                        <div className="toggle-switch" />
                      </label>
                </div>
              </div>
            </div>
          </div>
              </>
            )
          }) : "No submissions yet"}
        </div>
      </div>
      {/* <div className="container-fluid px-lg-5">
        <div className='content-box px-0'>
          <div>
              <div className='icon-with-txt'>
                  <img src="./images/intermediate.svg" alt="" />
                  Indermediate
              </div>
              <div className='skill-duration'>56 mins ago</div>
          </div>
          <div className="row">
            <div className="col-lg-4">
              <div>
                <h3 className="video-title">Introduction</h3>
                <div className="video-frame">
                  <img src="./svg/play.svg" className="play-icon" alt="Play" />
                  <div className='shadow-circle delete'>
                    <img src="./svg/trash.svg" alt="" />
                  </div>
                </div>
                <div className='mt-3'>
                  <label className="toggle-switch-main mb-0">
                    <span className="toggle-label">Show in Portfolio</span>
                    <input className="toggle-checkbox" type="checkbox" />
                    <div className="toggle-switch"></div>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}

    </div>
    </Base>
  )
}

export default IntroductionVideo
